import {useTranslation} from 'react-i18next';
import ICON_WAIT_FOR_FREE_PLUS from '../../../../public/static/v4/badge/icon-wait-for-free-plus.svg';
import BadgeImgText from '../../../common/component/BadgeImgText';
import EllipsisText from '../../../common/component/EllipsisText';
import {IBadge} from '../../../common/type';
import MaxWidth from '../../../commonSub/component/MaxWidth';

interface IProps {
  badge: IBadge;
  title: string;
  hasBottomLine?: boolean;
  className?: string;
}

export default function WaitForFreePlusBanner({
  badge,
  title,
  hasBottomLine,
  className,
}: IProps) {
  const {t} = useTranslation();

  if (!badge.waitfree) {
    return null;
  }

  return (
    <MaxWidth hasMdWidth className={cn('px-29', className)}>
      <div className="h-73 flex justify-between items-center">
        <EllipsisText
          line={2}
          className="s13-medium-white light:text-black mr-12 flex-1"
        >
          {t('viewer_end_gidamu_plus_info', {
            contentname: title,
            value: badge.waitfree.hours,
          })}
        </EllipsisText>
        <BadgeImgText
          imgTextType="waitForFreePlus"
          path={ICON_WAIT_FOR_FREE_PLUS}
          textClassName="s13-bold-grey01 light:text-white"
          bgClassName="bg-white light:bg-grey-15"
          className="!px-4"
          height={24}
          label={t(badge.label)}
          waitfree={badge.waitfree}
        />
      </div>
      {hasBottomLine && <div className="h-1 bg-grey-03" />}
    </MaxWidth>
  );
}
